import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { TextButton } from '../../shared/ui';

interface IProps {
  minutes: number;
  seconds: number;
  onRefreshAuthCode: () => Promise<unknown>;
}

const pad = (value: number) => String(value).padStart(2, '0');

const Timer: FC<IProps> = ({ minutes = 1, seconds = 0, onRefreshAuthCode }) => {
  const durationSec = minutes * 60 + seconds;
  const [endTime, setEndTime] = useState(() => Date.now() + durationSec * 1000);
  const [secondsLeft, setSecondsLeft] = useState(durationSec);

  // One interval per countdown: a restart replaces it, unmount and zero stop it.
  useEffect(() => {
    const timerId = setInterval(() => {
      const left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setSecondsLeft(left);
      if (left === 0) clearInterval(timerId);
    }, 1000);

    return () => clearInterval(timerId);
  }, [endTime]);

  const getCode = async () => {
    try {
      await onRefreshAuthCode();
    } catch {
      toast.error('Не удалось отправить код повторно, попробуйте ещё раз');
      return;
    }
    setSecondsLeft(durationSec);
    setEndTime(Date.now() + durationSec * 1000);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex justify-center gap-[5px] text-ui-xs md:text-ui text-ink-muted mb-1">
        Вы можете запросить повторно код через{' '}
        <span className="w-[50px]">
          {pad(Math.floor(secondsLeft / 60))}:{pad(secondsLeft % 60)}
        </span>
      </div>
      {secondsLeft === 0 && (
        <TextButton tone="primary" underline="none" className="sm:px-[30px] text-ui md:text-body-l" onClick={getCode}>
          Запросить код повторно
        </TextButton>
      )}
    </div>
  );
};

export default Timer;
